import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import Radio from '@sats-group/ui-lib/react/radio';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import type { ShopInstallments as Props } from './shop-installments.types';

const ShopInstallments: React.FC<Props> = ({
  action,
  data,
  description,
  onSubmit,
  options,
  submit,
}) => (
  <form
    action={action}
    className="shop-installments"
    method="post"
    onSubmit={onSubmit}
  >
    {data.map(entry => (
      <HiddenInput {...entry} key={entry.name} />
    ))}
    <Text elementName="p" tight>
      {description}
    </Text>
    <div className="shop-installments__entries">
      <Text elementName="h3" theme={Text.themes.emphasis}>
        {options.title}
      </Text>
      {options.entries.map(entry => (
        <div className="shop-installments__entry" key={entry.name}>
          <Radio {...entry} />
        </div>
      ))}
    </div>
    <div>
      <Button
        text={submit}
        type="submit"
        variant={Button.variants.complete}
        wide
      />
    </div>
  </form>
);

export default ShopInstallments;
